import {
  STATES,
  districtsForState,
  mandalsForDistrict,
  findDistrictForMandal,
  makeCityCode,
} from '../data/indiaLocations';

function norm(s) {
  return String(s || '')
    .trim()
    .toLowerCase()
    .replace(/\s*\(urban\)\s*/gi, '')
    .replace(/\s*rural\s*$/i, '')
    .replace(/\s+(district|mandal|taluk|tehsil|division)$/i, '')
    .trim();
}

function pickBestMatch(raw, options) {
  if (!raw || !options?.length) return '';
  const n = norm(raw);
  if (!n) return '';
  const exact = options.find((o) => norm(o) === n);
  if (exact) return exact;
  const contains = options.find((o) => norm(o).includes(n) || n.includes(norm(o)));
  return contains || '';
}

export function matchStateName(raw) {
  if (!raw) return '';
  const n = norm(raw);
  return (
    STATES.find((s) => norm(s) === n) ||
    STATES.find((s) => n.includes(norm(s)) || norm(s).includes(n)) ||
    ''
  );
}

export function matchDistrictName(state, raw) {
  if (!state || !raw) return '';
  return pickBestMatch(raw, districtsForState(state));
}

export function matchMandalName(state, district, ...candidates) {
  if (!state || !district) return '';
  const mandals = mandalsForDistrict(state, district);
  for (const raw of candidates) {
    const hit = pickBestMatch(raw, mandals);
    if (hit) return hit;
  }
  return '';
}

function tokensFromAddress(address) {
  if (!address) return [];
  return String(address)
    .split(',')
    .map((p) => p.trim())
    .filter(Boolean);
}

/**
 * Map reverse-geocode fields to canonical state / district / mandal names.
 */
export function resolveFromGeocode(loc = {}) {
  const parts = tokensFromAddress(loc.address || loc.display);
  const candidates = [
    loc.city,
    loc.district,
    loc.locality,
    ...parts,
  ].filter(Boolean);

  let state = matchStateName(loc.state);
  if (!state) {
    for (const p of parts) {
      const hit = matchStateName(p);
      if (hit) {
        state = hit;
        break;
      }
    }
  }

  let district = matchDistrictName(state, loc.district);
  if (!district) {
    for (const c of [loc.city, loc.district, ...parts]) {
      const hit = matchDistrictName(state, c);
      if (hit) {
        district = hit;
        break;
      }
    }
  }
  if (!district && state) {
    for (const c of candidates) {
      const hit = findDistrictForMandal(state, c);
      if (hit) {
        district = hit;
        break;
      }
    }
  }

  let mandal = matchMandalName(state, district, loc.city, loc.district, ...parts);
  if (!mandal && district && state) {
    const mandals = mandalsForDistrict(state, district);
    if (mandals.length === 1) mandal = mandals[0];
  }

  return {
    state: state || '',
    district: district || '',
    city: mandal || '',
    mandal: mandal || '',
    cityCode: state && mandal ? makeCityCode(state, district, mandal) : '',
  };
}
